import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RiskToleranceValue from './RiskToleranceValue';

export default function ClientRiskToleranceValue({ client, onChange, ...props }) {
  const [value, setValue] = useState(client.attr('riskTolerance'));

  function handleValueChange(val) {
    const oldValue = client.attr('riskTolerance');
    if (oldValue !== val) {
      client.attr('riskTolerance', val);
      setValue(val);
      if (onChange) {
        onChange(val);
      }
    }
  }

  return (<RiskToleranceValue
    key={client.id()}
    name={client.attr('name')}
    value={value}
    readonly={client.attr('readonly') === 'true'}
    onValueChange={handleValueChange}
    {...props}
  />);
}

ClientRiskToleranceValue.propTypes = {
  client: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

ClientRiskToleranceValue.defaultProps = {
  onChange: undefined,
};
